<template>
  <Skeleton
      width="320px"
      height="100%"
      v-if="appState.initial"
  ></Skeleton>
  <FloatLabel variant="on" class="chat-widget__w-100" v-else>
    <Select
        v-model="userInput.selectedModel"
        :options="groups || models"
        :optionDisabled="isOptionDisabled"
        optionLabel="name"
        :optionGroupLabel="groups ? 'name' : undefined"
        :optionGroupChildren="groups ? 'models' : undefined"
        scroll-height="21rem"
       :resetFilterOnHide="true"
        placeholder="Выберите модель"
        class="chat-widget__w-100"
        append-to="self"
        filter
        @change="chatState.modelChangeHandle"
        inputId="on_label_model"
    >
      <template #optiongroup="slotProps">
        <div>
          <div># {{ slotProps.option.name }}</div>
        </div>
      </template>
      <template #value="slotProps">
        <div v-if="slotProps.value">
          <div>
            {{ slotProps.value.name }}&nbsp;<Badge :value=slotProps.value.cost_label v-if="slotProps.value.cost_label" severity="secondary"></Badge>
          </div>
        </div>
        <span v-else>
          {{ slotProps.placeholder }}
        </span>
      </template>
      <template #option="slotProps">
        <div class="chat-widget__model-select--option">
          <i class="pi pi-lock" v-if="!slotProps.option.opened"></i>&nbsp;
          <div>
            {{ slotProps.option.name }}&nbsp;<Badge :value=slotProps.option.cost_label v-if="slotProps.option.cost_label" severity="secondary"></Badge>
          </div>
          <div v-if="!slotProps.option.opened">
            (доступно после регистрации)
          </div>
        </div>
      </template>
    </Select>
    <label for="on_label_model">{{ userInput.selectedModel ? 'Модель' : '' }}</label>
  </FloatLabel>
</template>
<script setup>
import Select from 'primevue/select';
import Skeleton from 'primevue/skeleton';
import FloatLabel from 'primevue/floatlabel';
import Badge from 'primevue/badge';
import {useChatStore} from "@/modules/chat/stores/chatStore";
import {useReferenceStore} from '@/modules/chat/stores/referenceStore';
import {useInputStore} from '@/modules/chat/stores/userInputStore';
import {useAppStateStore} from '@/modules/chat/stores/appStore';
import {computed} from "vue";
import {MODE_IMAGE, MODE_MUSIC, MODE_ONLINE} from "@/constants";
import {groupModels} from "@/modules/chat/services/selectGroup";

const reference = useReferenceStore();
const userInput = useInputStore();
const appState = useAppStateStore();
const chatState = useChatStore();
const isOptionDisabled = (option) => !option.opened;

const models = computed(() => {
  const models = reference.models.filter(model => {
    if (appState.mode === MODE_IMAGE) {
      return model.image;
    }
    if (appState.mode === MODE_ONLINE) {
      return model.online;
    }
    if (appState.mode === MODE_MUSIC) {
      return model.music;
    }
    return !model.image && !model.music;
  });
  if (appState.mode === MODE_IMAGE) {
    // отсортировать по полю name
    return models.sort((a, b) => a.name.localeCompare(b.name));
  }
  return models;
});

const groups = computed(() => {
  if (appState.mode === MODE_IMAGE || appState.mode === MODE_ONLINE || appState.mode === MODE_MUSIC) {
    return null;
  }
  return groupModels(models.value);
});

</script>